import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Currencies', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  currencies: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  currencies: state => state.currencies
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
